import React, { useEffect, useState } from "react";
import DynamicTable from "../../../components/DynamicTable/DynamicTable";
import { useDispatch, useSelector } from "react-redux";
import GetJobId from "../../../_utilities/GetJobId";
import {
  deleteProjectApplicantsAsync,
  deleteProjectApplicantsStartReducer,
  getProjectApplicantsAsync,
  getProjectApplicantsStartReducer,
} from "../../../_redux/_services/ProjectsSlice";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import SendSms from "../../../components/SendSms/SendSms";
import { GetUserInfo } from "../../../_utilities/getUserInfo";
import GenerateTemplateNew from "../../../components/GenerateTemplate/GenerateTemplateNew";
import FloatingMenu from "../../../components/FloatingMenu/FloatingMenu";
import { AssociatedApplicantsfloatingMenuOptions } from "../../../constants/floatingMenuConstants";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import WarningPopup from "../../../components/WarningPopup/WarningPopup";
import EmailDeliverySummary from "../../../components/EmailDeliverySummary";

const initalState = { data: null, message: "", isloader: true };

const ProjectAssociatedApplicants = () => {
  const [filterValue, setFilterValue] = useState("");
  const [config, setConfig] = useState(configuration);
  const [isSendsms, setIsSendsms] = useState(false);
  const [smsCandidates, setSmsCandidates] = useState([]);
  const [isSendEmail, setIsSendEmail] = useState(false);
  const [emailCandidates, setEmailCandidates] = useState([]);
  const [applicantCodes, setApplicantCodes] = useState([]);
  const [AssociatedApplicants, setAssociatedApplicants] = useState([]);
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [warningPopupDetails, setWarningPopupDetails] = useState({
    title: "",
    btnName: "",
  });
  const dispatch = useDispatch();
  const getJobCode = GetJobId();

  useEffect(() => {
    if (getJobCode) {
      const payload = {
        id: getJobCode,
        limit: config.limitData,
        offset: config.currentPage,
      };
      GetData(payload);
    }
  }, [getJobCode]);

  const projectApplicantsResponse = useSelector(
    (state) => state.GetProjectApplicants.data,
  );
  const DeleteProjectApplicantsStatus = useSelector(
    (state) => state.DeleteProjectApplicants.data,
  );

  const GetData = async (payload) => {
    setAssociatedApplicants([]);
    dispatch(getProjectApplicantsAsync(payload));
  };

  const resetData = async () => {
    const payload = {
      id: getJobCode,
      limit: config.limitData,
      offset: 1, // (config.currentPage - 1) * config.limitData + 1,
    };
    GetData(payload);
    let configure = JSON.parse(JSON.stringify(config));
    configure.currentPage = 1;
    setConfig(configure);
  };

  useEffect(() => {
    if (
      projectApplicantsResponse !== null &&
      projectApplicantsResponse?.rows?.length > 0
    ) {
      let projectApplicants = JSON.parse(
        JSON.stringify(projectApplicantsResponse),
      );
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = projectApplicants.total_count; /// config.limitData;
      setConfig(configure);
      projectApplicants.rows.forEach((item) => {
        item["aId"] = item.id;
        item["id"] = item.applicantId;
      });
      setAssociatedApplicants(projectApplicants.rows);
      // dispatch(getProjectApplicantsStartReducer(initalState));
    } else if (projectApplicantsResponse?.rows?.length === 0) {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = projectApplicantsResponse?.rows?.length;
      setConfig(configure);
    }
  }, [projectApplicantsResponse]);

  const onReceiveActionHandler = (type, obj) => {
    if (type === "pageRange") {
      setConfig({ ...config, limitData: obj, recordperPage: obj, currentPage: 1 });
      const payload = {
        id: getJobCode,
        limit: obj,
        offset: 1,
        keyword: obj.keyword || filterValue || "",
      };
      GetData(payload);
    } else if (type === "pagination") {
      const payload = {
        id: getJobCode,
        limit: obj.limit,
        offset: obj.offset,
        keyword: filterValue || "",
      };
      GetData(payload);
      let configure = JSON.parse(JSON.stringify(config));
      configure.currentPage = obj.current;
      setConfig(configure);
    } else if (type === "searchResult") {
      if (obj.keyword !== "") {
        obj.offset = obj.offset ? obj.offset : 1;
        setFilterValue(obj.keyword);
        const payload = {
          id: getJobCode,
          limit: config.limitData,
          offset: obj.offset,
          keyword: obj.keyword,
        };
        GetData(payload);
      }
    } else if (type === "cancelSearchResult") {
      setFilterValue("");
      resetData();
    } else if (type === "Send SMS") {
      setIsSendsms(true);
      // const updateSmsCandidates = obj.map(list => ({ ...list, id: list.applicantId }));
      setSmsCandidates(obj);
    } else if (type === "Send E-mail") {
      setIsSendEmail(true);
      const updateEmailCandidates = obj.map((list) => ({
        ...list,
        certification: JSON.parse(list?.certification),
        skillDetails: JSON.parse(list?.skillDetails),
        workExp: JSON.parse(list?.workExp),
        educationDetails: JSON.parse(list?.educationDetails),
      }));
      setEmailCandidates(updateEmailCandidates);
      // const applicantCodes = obj.map(x => x.applicantCode);
      setApplicantCodes(obj);
    } else if (type === "confirmDel") {
      DeleteRecords(obj);
    } else if (type === "selectedRows") {
      setSelectedApplicants(obj);
    } else if (
      type === "sendSMS" ||
      type === "sendEmail" ||
      type === "delete"
    ) {
      if (selectedApplicants.length > 0) {
        if (type === "sendSMS") {
          onReceiveActionHandler("Send SMS", selectedApplicants);
        } else if (type === "sendEmail") {
          onReceiveActionHandler("Send E-mail", selectedApplicants);
        } else if (type === "delete") {
          setWarningPopupDetails({
            title: "Are you sure you want to delete",
            btnName: "Delete",
          });
          setOpenDeleteConfirm(true);
        }
      } else {
        dispatch(
          updateSnackbar({ type: "error", message: "No record selected" }),
        );
      }
    }
  };

  const DeleteRecords = async (object) => {
    let ids;
    if (typeof object === "object" && object.length > 0) {
      ids = object.map((x) => x.applicantId.toString());
    } else {
      ids = [object.toString()];
    }
    dispatch(
      deleteProjectApplicantsAsync({ applicantId: ids, projectId: getJobCode }),
    );
  };

  const handleConfirmDelete = () => {
    onReceiveActionHandler("confirmDel", selectedApplicants);
    setOpenDeleteConfirm(false);
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirm(false);
  };

  useEffect(() => {
    if (DeleteProjectApplicantsStatus === 200) {
      resetData();
      setFilterValue("");
      dispatch(deleteProjectApplicantsStartReducer(initalState));
    }
  }, [DeleteProjectApplicantsStatus]);

  const onReceivePropsHandler = (pannel, load, bool) => {
    setIsSendsms(pannel);
    setIsSendEmail(pannel);
    resetData();
    if (!pannel) {
      setSmsCandidates([]);
      setEmailCandidates([]);
      setSelectedApplicants([]);
    }
  };

  useEffect(() => {
    const userInfo = GetUserInfo();
    const updatedConfig = userInfo
      ? (() => {
          const newConfig = { ...config };
          let updatedMenuOptions =
            AssociatedApplicantsfloatingMenuOptions?.menuOptions;
          // Remove Send SMS if integrations are not enabled
          const integrations = userInfo[0]?.integrations
            ? JSON.parse(userInfo[0].integrations)
            : [];
          const ringCentralIntegration = integrations.find(
            (i) =>
              i.attribute_5 === "Ring Central" &&
              i.attribute_3?.includes("Messages"),
          );

          if (
            !integrations ||
            !ringCentralIntegration ||
            ringCentralIntegration.active === null
          ) {
            updatedMenuOptions = updatedMenuOptions.filter(
              (a) => a.action !== "sendSMS",
            );
          }
          newConfig.menuOptions = updatedMenuOptions;
          return newConfig;
        })()
      : configuration;
    setConfig(updatedConfig);
  }, []);

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <div className="projectAssociatedApplicantsCSS">
      <div className="projectAssociatedApplicantsfloatbtn">
        <FloatingMenu
          config={config}
          floatingMenuOptions={AssociatedApplicantsfloatingMenuOptions}
          onReceiveActionHandler={onReceiveActionHandler}
          storedTheme={storedTheme}
        />
      </div>
      <WarningPopup
        open={openDeleteConfirm}
        handleClose={handleCancelDelete}
        handleConfirm={handleConfirmDelete}
        details={warningPopupDetails}
      />
      {AssociatedApplicants && AssociatedApplicants.length === 0 && (
        <DynamicTable
          config={config}
          data={AssociatedApplicants}
          colmns={columnsData}
          actionDropdown={
            config.actionsDropdownData
              ? config.actionsDropdownData
              : actionsDropdownData
          }
          filterValue={filterValue}
          searchKeyWord="Search Applicant"
          actions={actionsList}
          addModel={addNewModel}
          noDataText="No Applicants Found"
          onReceiveActionProps={(type, obj) =>
            onReceiveActionHandler(type, obj)
          }
        />
      )}
      {AssociatedApplicants && AssociatedApplicants.length > 0 && (
        <DynamicTable
          config={config}
          data={AssociatedApplicants}
          colmns={columnsData}
          actionDropdown={
            config.actionsDropdownData
              ? config.actionsDropdownData
              : actionsDropdownData
          }
          filterValue={filterValue}
          searchKeyWord="Search Applicant"
          actions={actionsList}
          addModel={null}
          nodataText="No Applicants Found"
          onReceiveActionProps={(type, obj) =>
            onReceiveActionHandler(type, obj)
          }
        />
      )}

      {isSendsms ? (
        <div id="sendSms">
          <RightSideBar
            componentData={
              <SendSms
                data={smsCandidates}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={smsObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : isSendEmail ? (
        <RightSideBar
          componentData={
            <GenerateTemplateNew
              isAssociatedProfile={false}
              applicantDetails={emailCandidates[0]}
              tempApplicant={null}
              applicantCodes={applicantCodes}
              jobCode={null}
              onReceiveProps={onReceivePropsHandler}
              to={"applicants"}
            />
          }
          componentLayout={MailOBJ}
          onReceiveProps={onReceivePropsHandler}
        />
      ) : null}
      <EmailDeliverySummary candidateMailId={applicantCodes[0]?.emailId}/>
    </div>
  );
};

export default ProjectAssociatedApplicants;

const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: true,
  isActions: true,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 10,
  isCheckAlignRight: true,
  isPaginationTop: true,
  isSearchServer: true,
  isPagingServer: true,
  isPageRange: true,
};

const columnsData = [
  {
    id: 1,
    displayName: "Applicant Code",
    type: "Applicant Code",
    mappingName: "applicantCode",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "120px",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
    openNewTab: true,
  },
  {
    id: 2,
    displayName: "Applicant Name",
    type: "Applicant Code",
    mappingName: "fullName",
    theadClass: "dynatableheadtext text-center ",
    tbodyClass: "dynatablebodytext  text-center NameCapitalise",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 3,
    displayName: "Contact Number",
    type: "Applicant Code",
    mappingName: "contactNumber",
    theadClass: "dynatableheadtext text-center  ",
    tbodyClass: "dynatablebodytext text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 4,
    displayName: "E-mail ID",
    type: "Applicant Code",
    mappingName: "emailId",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytextemail text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 5,
    displayName: "Created By",
    type: "Applicant Code",
    mappingName: "createdBy",
    theadClass: "dynatableheadtext text-center ",
    tbodyClass: "dynatablebodytext text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
];

const actionsList = {
  isDownload: false,
  isDelete: true,
};

const actionsDropdownData = ["Delete", "Send E-mail", "Send SMS"];

const addNewModel = {
  url: "",
  displayName: "",
};

const smsObj = {
  title: "Send SMS",
  description: "",
  bgImage: "",
};

const MailOBJ = {
  title: "E-mail",
  description: "",
  bgImage: `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};
